export default "__VITE_ASSET__qzF70U4$__"